import convertableUnitsObject from './convertableUnitsObject';

/**
 * Convert all the values keys of the array of objects to the extra unit
 * @param {array} arr
 * @param {string} key
 * @param {object} coopConfig
 * @returns {string} the formatted value with the extra unit abbreviation
 */
const convertableUnitsArrayObject = (arr, coopConfig, keys = ['value']) => {
  if (coopConfig.hasAcopioUnitsExtra()) {
    const newArr = arr.map(item => {
      return {
        ...item,
        ...convertableUnitsObject(item, coopConfig, keys),
      };
    });
    return newArr;
  }
  return arr;
};

export default convertableUnitsArrayObject;
